/**
 * Site → default author registry (mirror of backend `data/authors.py`).
 * Used by BlogCard and article headers to render an author avatar + name
 * without a round-trip to the API for every card.
 *
 * `image` is optional — if the file is missing, we fall back to initials on a
 * solid brand-tinted circle.
 */
export const AUTHORS = {
  'vikas-goel': {
    slug: 'vikas-goel',
    name: 'Vikas Goel',
    site: 'vikasifications',
    role: 'Founder · Author · Speaker',
    image: '/authors/vikas-goel.jpg',
  },
  'sanuj-malik': {
    slug: 'sanuj-malik',
    name: 'Sanuj Malik',
    site: 'all',
    role: 'Senior Editor · Growth & Consumer Tech',
    image: '/authors/sanuj-malik.jpg',
  },
  'snigdharani-mohanty': {
    slug: 'snigdharani-mohanty',
    name: 'Snigdharani Mohanty',
    site: 'all',
    role: 'Contributing Editor · Deals & Finance',
    image: '/authors/snigdharani-mohanty.jpg',
  },
  'biswa-bikash-panda': {
    slug: 'biswa-bikash-panda',
    name: 'Biswa Bikash Panda',
    site: 'all',
    role: 'Staff Writer · Auto, Travel & Games',
    image: '/authors/biswa-bikash-panda.jpg',
  },
  'dgtg-team': {
    slug: 'dgtg-team',
    name: 'DGTG Team',
    site: 'dgtg',
    role: 'Digital Growth Editorial',
    image: '/authors/dgtg-team.jpg',
  },
  'devmob-team': {
    slug: 'devmob-team',
    name: 'DevMob Team',
    site: 'devmob',
    role: 'Technology Services Editorial',
    image: '/authors/devmob-team.jpg',
  },
  'gamesnfans-editor': {
    slug: 'gamesnfans-editor',
    name: 'GamesNFans Editorial',
    site: 'games',
    role: 'Esports & Cricket Editorial',
    image: '/authors/gamesnfans-editor.jpg',
  },
  'ymw-editorial': {
    slug: 'ymw-editorial',
    name: 'YourMoneyWise Editorial',
    site: 'finance',
    role: 'Personal Finance Editorial',
    image: '/authors/ymw-editorial.jpg',
  },
  'cbp-editorial': {
    slug: 'cbp-editorial',
    name: 'CarsbikesPrices Editorial',
    site: 'auto',
    role: 'Automotive Editorial',
    image: '/authors/cbp-editorial.jpg',
  },
  'mm-editorial': {
    slug: 'mm-editorial',
    name: 'MetroMandi Editorial',
    site: 'coupon',
    role: 'Deals & Coupons Editorial',
    image: '/authors/mm-editorial.jpg',
  },
  'woketraveler-editor': {
    slug: 'woketraveler-editor',
    name: 'WokeTraveler Editorial',
    site: 'travel',
    role: 'Conscious Travel Editorial',
    image: '/authors/woketraveler-editor.jpg',
  },
  'tech-n-ai-editor': {
    slug: 'tech-n-ai-editor',
    name: 'Tech-N-AI Talks Editorial',
    site: 'tech',
    role: 'AI, SaaS & Gadgets Editorial',
    image: '/authors/tech-n-ai-editor.jpg',
  },
};

export const DEFAULT_AUTHOR_BY_SITE = {
  vikas: 'vikas-goel',
  vikasifications: 'vikas-goel',
  dgtg: 'dgtg-team',
  devmob: 'devmob-team',
  games: 'gamesnfans-editor',
  finance: 'ymw-editorial',
  auto: 'cbp-editorial',
  coupon: 'mm-editorial',
  travel: 'woketraveler-editor',
  tech: 'tech-n-ai-editor',
};

/** Base URL prefix for each site's public author page. */
export const SITE_BASE = {
  vikas: '/vikas',
  vikasifications: '/vikas',
  dgtg: '/dgtg',
  devmob: '/devmob',
  games: '/games',
  finance: '/finance',
  auto: '/auto',
  coupon: '/coupons',
  travel: '/travel',
  tech: '/tech',
};

/** Resolve an author record given an article's `author` name (fuzzy) + site. */
export function resolveAuthor(name, site) {
  if (name) {
    const match = Object.values(AUTHORS).find(
      (a) => a.name.toLowerCase() === String(name).toLowerCase()
    );
    if (match) return match;
  }
  const slug = DEFAULT_AUTHOR_BY_SITE[site];
  return slug ? AUTHORS[slug] : null;
}

/** Build the URL to an author's public profile page for a given site. */
export function authorHref(author, site) {
  if (!author) return '';
  const base = SITE_BASE[site] || SITE_BASE[author.site] || '';
  return `${base}/author/${author.slug}`;
}
